/* NovaHair concierge dock.
 *
 * The AI concierge opens only when the popup engine decides a shopper is about
 * to leave. This test gives half the visitors a small button that is always
 * there ("שאלה על הגוון? דברי איתי") so they can open the same concierge
 * whenever they want. The app decides the arm from the visitor key (same hash
 * as every other first-party test), the assignment is written where the live
 * beacon reads it, and the cart carries it so the order can be attributed.
 *
 * Loaded by the sales page layout after the concierge scripts. ES5 on purpose.
 */
(function (global) {
  'use strict';
  var doc = document;
  if (!/^\/pages\//.test(global.location.pathname)) return;
  var EXPERIMENT = 'nova_concierge_dock_v1';
  var ENDPOINT = '/apps/funnels/api/popup/offer-variant';
  var STORAGE = 'nh_experiments';

  function cookie(name) { var m = doc.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)')); return m ? decodeURIComponent(m[1]) : ''; }
  function visitorKey() {
    var fromCookie = cookie('_fc_visitor');
    if (/^[A-Za-z0-9_-]{8,120}$/.test(fromCookie)) return fromCookie;
    try {
      var stored = global.localStorage.getItem('nh_live_visitor');
      if (stored) return stored;
      var fresh = 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
      global.localStorage.setItem('nh_live_visitor', fresh);
      return fresh;
    } catch (_) { return 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12); }
  }
  function remember(variant) {
    try {
      var all = JSON.parse(global.localStorage.getItem(STORAGE) || '{}');
      if (!all || typeof all !== 'object') all = {};
      all[EXPERIMENT] = variant;
      global.localStorage.setItem(STORAGE, JSON.stringify(all));
    } catch (_) {}
    var tag = function () {
      return global.fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { nova_concierge_dock: variant } })
      }).catch(function () {});
    };
    if (typeof global.novaFunnelEnqueueCartMutation === 'function') global.novaFunnelEnqueueCartMutation('nova-concierge-dock', tag); else tag();
  }
  function capture(name, props) {
    try { if (global.posthog && typeof global.posthog.capture === 'function') global.posthog.capture(name, props || {}); } catch (_) {}
  }

  var css = ''
    + '.nh-dock{position:fixed;right:14px;bottom:var(--nh-dock-bottom,110px);z-index:9000;display:flex;align-items:center;gap:10px;'
    + 'max-width:calc(100vw - 28px);padding:10px 14px 10px 10px;border:0;border-radius:999px;background:#17231e;color:#fff;font:600 14px/1.2 "Heebo","Assistant",system-ui,sans-serif;'
    + 'box-shadow:0 10px 30px rgba(20,31,26,.28),0 2px 6px rgba(20,31,26,.18);cursor:pointer;direction:rtl;transition:transform .18s ease,opacity .18s ease}'
    + '.nh-dock:active{transform:scale(.97)}'
    + '.nh-dock__face{width:34px;height:34px;border-radius:50%;background:radial-gradient(circle at 30% 30%,#f5d0c4,#d98a73);flex:0 0 auto;display:grid;place-items:center;font-size:17px}'
    + '.nh-dock__text{white-space:nowrap;overflow:hidden;max-width:220px;transition:max-width .25s ease,opacity .25s ease,margin .25s ease}'
    + '.nh-dock--mini .nh-dock__text{max-width:0;opacity:0;margin:0}'
    + '.nh-dock--mini{padding:8px}'
    + '.nh-dock__dot{position:absolute;top:6px;right:6px;width:9px;height:9px;border-radius:50%;background:#34c759;box-shadow:0 0 0 2px #17231e}'
    + 'body.nh-ai-open .nh-dock,body.nova-ai-open .nh-dock,body.nh-exit-popup-open .nh-dock{opacity:0;pointer-events:none}'
    + '@media (max-width:480px){.nh-dock{right:12px}}'
    + '.nh-dock{background:#fff;color:#B94F18;border:1.5px solid #E07A28;font-family:"Open Sans","Arial Hebrew",Arial,sans-serif;font-weight:800;box-shadow:0 8px 22px rgba(224,122,40,.22),0 2px 6px rgba(0,0,0,.08);padding:9px 16px 9px 10px}.nh-dock__face{background:#FFF1E6}.nh-dock__face svg{width:20px;height:20px;fill:none;stroke:#E07A28;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.nh-dock--mini{padding:7px}.nh-dock__dot{display:none}';

  function mount() {
    if (doc.querySelector('.nh-dock')) return;
    var style = doc.createElement('style'); style.textContent = css; doc.head.appendChild(style);
    var button = doc.createElement('button');
    button.type = 'button';
    button.className = 'nh-dock';
    button.setAttribute('aria-label', 'שאלה על הגוון? דברי עם היועצת');
    button.innerHTML = '<span class="nh-dock__face" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 5.5h16v10H9l-5 4v-14z"/><path d="M8.5 10.5h.01M12 10.5h.01M15.5 10.5h.01"/></svg></span><span class="nh-dock__text">שאלה על הגוון? דברי איתי</span>';
    doc.body.appendChild(button);
    var shownAt = Date.now();

    /* The moment engine, in its smallest form. Each moment is a thing she just did, a line
       that answers it, and a rank. The highest-ranked moment that is true wins; when none is,
       the button keeps its opening line. Rank matters because two can be true at once: a
       shopper who changed shades twice and then went quiet at the price wants the price line. */
    var DEFAULT_LABEL = 'שאלה על הגוון? דברי איתי';
    var moments = [
      { id: 'shade_doubt', rank: 1, label: 'מתלבטת בין גוונים? אני אעזור', test: function (s) { return s.shadeChanges >= 2 && !s.addedToCart; } },
      { id: 'price_pause', rank: 2, label: 'שאלה על המחיר או המשלוח?', test: function (s) { return s.sawPrice && s.idleSeconds >= 12 && !s.addedToCart; } },
      { id: 'deep_no_cart', rank: 0, label: 'רוצה שאעזור לך לבחור?', test: function (s) { return s.maxDepth >= 60 && !s.addedToCart; } }
    ];
    var signals = { shadeChanges: 0, sawPrice: false, addedToCart: false, maxDepth: 0, idleSeconds: 0, lastAction: Date.now() };
    var currentMoment = null;

    /* nh-cd v1 (27.10.2026, Harel "1 + 3 do it"): half of the women who tap the button get the shade answer first.
       30 days to 26.10: a tap in shade doubt opened the "still checking / already bought" interview; 28 of 327 reached
       the shade part and those who opened bought no more than those who did not (19.2% vs 19.9%). Taps on the price
       line keep today's conversation in both halves (17.6% vs 9.9% there). Arm = FNV(visitor + ':nh_cd_v1') % 2, the
       same visitor id the orders carry (nova_visitor), so every opener can be matched to her order. B's sheet is this
       file's own: it reads shades, photos, packs and prices from the page and adds to the cart through the page's own
       buttons, so the price test and the other page tests keep working. Events: nh_cd_open / nh_cd_step / nh_cd_cart /
       nh_cd_close, and nh_cd is registered on every later event (props.nh_cd). Force with ?nh_cd=a|b. */
    var CD = { open: false, root: null, log: null, foot: null, shade: null, pack: null, step: '' };
    function cdFnv(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
    function cdArm() { var f = /[?&]nh_cd=([ab])(?:&|$)/.exec(global.location.search); return f ? f[1] : (cdFnv(visitorKey() + ':nh_cd_v1') % 2 ? 'b' : 'a'); }
    function cdShades() {
      var out = [], nodes = doc.querySelectorAll('.nh-shade-option-v2[data-color]');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i], k = n.getAttribute('data-color');
        if (!k || out.some(function (s) { return s.k === k; })) continue;
        out.push({ k: k, label: n.getAttribute('data-label') || k, img: String(n.getAttribute('data-image') || '').replace(/width=\d+/, 'width=240'), hex: (n.getAttribute('style') || '').replace(/.*--nhs-fallback:\s*([^;]+).*/, '$1') });
      }
      return out;
    }
    function cdPacks() {
      var box = doc.querySelector('.bundle-cards-container'), out = [];
      if (!box) return out;
      var cards = box.querySelectorAll('.bundle-card[data-offer]');
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i], q = function (sel) { var x = c.querySelector(sel); return x ? x.textContent.replace(/\s+/g, ' ').trim() : ''; };
        if (c.offsetParent === null && getComputedStyle(c).display === 'none') continue;
        out.push({ offer: c.getAttribute('data-offer'), title: q('.bundle-card__title'), price: q('.bundle-card__price'), badge: q('.bundle-card__badge-inline'), card: c });
      }
      return out;
    }
    function cdEligible() { return cdShades().length >= 3 && cdPacks().length > 0 && !!doc.getElementById('mainCheckout'); }
    function cdEnter(arm, moment) {
      try { if (global.posthog && typeof global.posthog.register === 'function') global.posthog.register({ nh_cd: arm }); } catch (_) {}
      try { global.localStorage.setItem('nh_cd', arm + '.' + Date.now()); } catch (_) {}
      capture('nh_cd_open', { nh_cd: arm, moment: moment || 'label', path: global.location.pathname });
      var tag = function () { return global.fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { nova_cd: 'cd-' + arm } }) }).catch(function () {}); };
      if (typeof global.novaFunnelEnqueueCartMutation === 'function') global.novaFunnelEnqueueCartMutation('nova-cd', tag); else tag();
    }
    function cdEl(tag, cls, text) { var n = doc.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
    function cdScroll() { if (CD.log) CD.log.scrollTop = CD.log.scrollHeight; }
    function cdSay(text, instant) {
      return new Promise(function (resolve) {
        if (instant) { CD.log.appendChild(cdEl('div', 'nhai__msg nhai__msg--ai', text)); cdScroll(); resolve(); return; }
        var t = cdEl('div', 'nhai__msg nhai__msg--ai nhai__typing'); t.appendChild(cdEl('i')); t.appendChild(cdEl('i')); t.appendChild(cdEl('i'));
        CD.log.appendChild(t); cdScroll();
        global.setTimeout(function () { if (!CD.open) return; t.remove(); CD.log.appendChild(cdEl('div', 'nhai__msg nhai__msg--ai', text)); cdScroll(); resolve(); }, Math.min(380 + text.length * 6, 900));
      });
    }
    function cdUser(text) { CD.log.appendChild(cdEl('div', 'nhai__msg nhai__msg--user', text)); cdScroll(); }
    function cdStep(step, extra) { CD.step = step; var p = { nh_cd: 'b', step: step }; for (var k in extra || {}) p[k] = extra[k]; capture('nh_cd_step', p); }
    function cdOpt(label, fn, cls) { var b = cdEl('button', 'nhai__opt' + (cls ? ' ' + cls : ''), label); b.type = 'button'; b.addEventListener('click', fn); return b; }
    function cdTiles(list, cols) {
      var grid = cdEl('div', 'nhcd__grid' + (cols === 3 ? ' nhcd__grid--3' : ''));
      list.forEach(function (s) {
        var b = cdEl('button', 'nhcd__tile'); b.type = 'button'; b.setAttribute('data-k', s.k);
        var img = cdEl('img'); img.alt = ''; img.decoding = 'async'; if (s.hex) img.style.background = s.hex; if (s.img) img.src = s.img;
        b.appendChild(img); b.appendChild(cdEl('b', null, s.label));
        b.addEventListener('click', function () { cdUser(s.label); cdChoose(s.k, 'tile'); });
        grid.appendChild(b);
      });
      return grid;
    }
    function cdFoot(nodes) { CD.foot.innerHTML = ''; nodes.forEach(function (n) { if (n) CD.foot.appendChild(n); }); global.requestAnimationFrame(cdScroll); }
    function cdByKey(k) { var all = cdShades(); for (var i = 0; i < all.length; i++) if (all[i].k === k) return all[i]; return null; }
    function cdPick(again) {
      cdStep(again ? 'pick_again' : 'pick');
      var row = cdEl('div', 'nhcd__row');
      row.appendChild(cdOpt('לא בטוחה', function () { cdUser('לא בטוחה'); cdUnsure(); }));
      row.appendChild(cdOpt('בין שני גוונים', function () { cdUser('בין שני גוונים'); cdBetween(); }));
      cdFoot([cdTiles(cdShades(), 4), row, again ? null : cdOpt('שאלה אחרת? מחיר, משלוח או שימוש', function () { capture('nh_cd_other', { nh_cd: 'b' }); cdClose('other'); openRegular(); }, 'nhai__opt--ghost')]);
    }
    function cdUnsure() {
      cdStep('unsure'); cdFoot([]);
      cdSay('בואי נצמצם. איזה צבע הכי קרוב לשאר השיער שלך?').then(function () {
        var box = cdEl('div', 'nhai__opts');
        if (cdByKey('black')) box.appendChild(cdOpt('שחור או כמעט שחור', function () { cdUser('שחור או כמעט שחור'); cdChoose('black', 'unsure'); }));
        box.appendChild(cdOpt('חום', function () { cdUser('חום'); cdFamily('brown', ['darkbrown', 'mediumbrown', 'lightbrown'], 'איזה מהם?'); }));
        box.appendChild(cdOpt('סגול, אדום או בלונד', function () { cdUser('סגול, אדום או בלונד'); cdFamily('other', ['purple', 'red', 'blonde'], 'איזה מהם?'); }));
        cdFoot([box]);
      });
    }
    function cdFamily(step, keys, line) {
      cdStep(step); cdFoot([]);
      var list = keys.map(cdByKey).filter(Boolean);
      cdSay(line).then(function () {
        cdFoot([cdTiles(list, 3), step === 'brown' ? cdOpt('בין שניים מהם', function () { cdUser('בין שניים מהם'); cdBetween(); }) : null, cdOpt('כל הגוונים', function () { cdPick(true); }, 'nhai__opt--ghost')]);
      });
    }
    function cdBetween() {
      cdStep('between'); cdFoot([]);
      var pairs = [['black', 'darkbrown'], ['darkbrown', 'mediumbrown'], ['mediumbrown', 'lightbrown'], ['lightbrown', 'blonde']];
      cdSay('מתלבטת בין שני גוונים? בחרי את הכהה.').then(function () { return cdSay('בין אילו שניים?'); }).then(function () {
        var box = cdEl('div', 'nhai__opts');
        pairs.forEach(function (p) {
          var d = cdByKey(p[0]), l = cdByKey(p[1]); if (!d || !l) return;
          var label = d.label + ' או ' + l.label;
          box.appendChild(cdOpt(label, function () { cdUser(label); cdSay('אז ' + d.label + ', הכהה מבין השניים.').then(function () { cdChoose(d.k, 'between'); }); }));
        });
        cdFoot([box, cdOpt('זוג אחר', function () { cdPick(true); }, 'nhai__opt--ghost')]);
      });
    }
    function cdChoose(k, via) {
      var s = cdByKey(k); if (!s) return;
      CD.shade = s; cdStep('shade', { shade: k, via: via }); cdFoot([]);
      var card = cdEl('div', 'nhai__card nhcd__shade'); var img = cdEl('img'); img.alt = ''; if (s.hex) img.style.background = s.hex; img.src = s.img; card.appendChild(img); card.appendChild(cdEl('b', null, s.label));
      CD.log.appendChild(card); cdScroll();
      cdSay('עכשיו בחרי מארז:').then(function () {
        var box = cdEl('div', 'nhai__opts');
        cdPacks().forEach(function (p) {
          var b = cdEl('button', 'nhai__opt nhcd__pack'); b.type = 'button';
          var left = cdEl('span'); if (p.badge) left.appendChild(cdEl('small', null, p.badge)); left.appendChild(document.createTextNode(p.title));
          b.appendChild(left); b.appendChild(cdEl('b', null, p.price));
          b.addEventListener('click', function () { cdUser(p.title + ' · ' + p.price); cdPack(p); });
          box.appendChild(b);
        });
        cdFoot([box, cdOpt('החליפי גוון', function () { cdPick(true); }, 'nhai__opt--ghost')]);
      });
    }
    function cdPack(p) {
      CD.pack = p; cdStep('pack', { shade: CD.shade.k, pack: p.offer }); cdFoot([]);
      cdSay(CD.shade.label + ', ' + p.title + ' ב־' + p.price + '.').then(function () {
        var go = cdOpt('הוסיפי לעגלה ›', function () { go.disabled = true; go.textContent = 'רגע…'; cdCart(); }, 'nhai__opt--primary nhcd__go');
        cdFoot([go, cdOpt('רוצה לשנות משהו?', function () { cdPick(true); }, 'nhai__opt--ghost')]);
      });
    }
    function cdCart() {
      var s = CD.shade, p = CD.pack;
      capture('nh_cd_cart', { nh_cd: 'b', shade: s.k, pack: p.offer });
      try { if (doc.querySelector('.mm-drawer[aria-hidden="false"]') && typeof global.toggleMixMode === 'function') global.toggleMixMode(); } catch (_) {}
      var real = doc.querySelector('.nh-shade-option-v2[data-color="' + s.k + '"]');
      if (real && real.getAttribute('aria-checked') !== 'true') real.click();
      try { if (typeof global.selectPack === 'function') global.selectPack(p.offer); else p.card.click(); } catch (_) { try { p.card.click(); } catch (__) {} }
      global.setTimeout(function () {
        cdClose('cart');
        var buy = doc.getElementById('mainCheckout');
        if (buy) buy.click();
      }, 250);
    }
    function cdKey(e) { if (CD.open && e.key === 'Escape') cdClose('esc'); }
    function cdClose(how) {
      if (!CD.open) return;
      CD.open = false;
      if (how !== 'cart' && how !== 'other') capture('nh_cd_close', { nh_cd: 'b', step: CD.step, how: how });
      if (CD.root) CD.root.remove();
      CD.root = CD.log = CD.foot = null;
      doc.body.classList.remove('nh-ai-open');
      doc.body.style.overflow = CD.overflow || '';
      doc.removeEventListener('keydown', cdKey);
    }
    function shadeFirst() {
      if (CD.open) return;
      if (!doc.getElementById('nhcd-css')) {
        var st = doc.createElement('style'); st.id = 'nhcd-css';
        st.textContent = '.nhcd .nhai__orb{background-size:cover;background-position:center top}'
          + '.nhcd__grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:7px;margin:0 0 9px}.nhcd__grid--3{grid-template-columns:repeat(3,minmax(0,1fr))}'
          + '.nhcd__tile{-webkit-appearance:none;appearance:none;margin:0;border:1.5px solid var(--line);background:#fff;border-radius:12px;padding:5px 4px 7px;display:flex;flex-direction:column;align-items:center;gap:5px;cursor:pointer;font:inherit;color:var(--ink);min-width:0}'
          + '.nhcd__tile img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:8px;display:block}'
          + '.nhcd__tile b{font-size:12.5px;font-weight:700;line-height:1.25;text-align:center}'
          + '.nhcd__tile:active{transform:scale(.97)}.nhcd__tile:focus-visible{outline:none;border-color:var(--accent)}'
          + '.nhcd__row{display:grid;grid-template-columns:1fr 1fr;gap:7px}.nhcd__row .nhai__opt{text-align:center}'
          + '.nhcd .nhai__foot>.nhai__opt{margin-top:7px;text-align:center}.nhcd .nhai__foot>.nhai__opt:first-child{margin-top:0}.nhcd .nhai__msg{text-wrap:balance}'
          + '.nhcd__pack{display:flex;align-items:center;justify-content:space-between;gap:10px}.nhcd__pack span{min-width:0}.nhcd__pack small{display:block;font-size:12px;font-weight:700;color:var(--accent);line-height:1.3}.nhcd__pack b{font-size:16px;white-space:nowrap;direction:ltr}'
          + '.nhcd__shade{display:flex;align-items:center;gap:12px;padding:9px 12px}.nhcd__shade img{width:58px;height:58px;border-radius:10px;object-fit:cover;flex:none}.nhcd__shade b{font-size:15px}'
          + '.nhcd__go{text-align:center;font-size:16px;min-height:52px}';
        doc.head.appendChild(st);
      }
      var root = cdEl('div', 'nhai nhcd'); root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'בחירת גוון'); root.setAttribute('data-open', 'true');
      var sheet = cdEl('div', 'nhai__sheet'), head = cdEl('div', 'nhai__head'), orb = cdEl('div', 'nhai__orb');
      var map = (global.NovaHairAIOptions && global.NovaHairAIOptions.assetMap) || {};
      if (map['img/advisor.png']) orb.style.backgroundImage = 'url(' + map['img/advisor.png'] + ')';
      var who = cdEl('div', 'nhai__who'); who.appendChild(cdEl('div', 'nhai__name', 'נעמה לוי')); who.appendChild(cdEl('div', 'nhai__sub', 'מומחית צביעת השיער של NovaHair'));
      var x = cdEl('button', 'nhai__x', '×'); x.type = 'button'; x.setAttribute('aria-label', 'סגירה'); x.addEventListener('click', function () { cdClose('x'); });
      head.appendChild(orb); head.appendChild(who); head.appendChild(x);
      CD.log = cdEl('div', 'nhai__log'); CD.foot = cdEl('div', 'nhai__foot');
      sheet.appendChild(head); sheet.appendChild(CD.log); sheet.appendChild(CD.foot); root.appendChild(sheet);
      root.addEventListener('click', function (e) { if (e.target === root) cdClose('backdrop'); });
      doc.body.appendChild(root);
      CD.root = root; CD.open = true; CD.shade = CD.pack = null;
      CD.overflow = doc.body.style.overflow; doc.body.style.overflow = 'hidden'; doc.body.classList.add('nh-ai-open');
      doc.addEventListener('keydown', cdKey);
      cdSay('היי, אני נעמה. בואי נמצא לך גוון.', true);
      cdSay('בחרי לפי צבע שאר השיער, לא לפי השורש הלבן.', true);
      cdPick(false);
      try { var first = CD.foot.querySelector('.nhcd__tile'); if (first) first.focus({ preventScroll: true }); } catch (_) {}
    }

    function labelNode() { return button.querySelector('.nh-dock__text'); }
    function applyMoment() {
      signals.idleSeconds = Math.round((Date.now() - signals.lastAction) / 1000);
      var best = null;
      for (var i = 0; i < moments.length; i++) {
        var m = moments[i];
        var hit = false;
        try { hit = m.test(signals); } catch (_) { hit = false; }
        if (hit && (!best || m.rank > best.rank)) best = m;
      }
      var next = best ? best.id : null;
      if (next === currentMoment) return;
      currentMoment = next;
      var node = labelNode();
      if (node) node.textContent = best ? best.label : DEFAULT_LABEL;
      if (best) {
        button.classList.remove('nh-dock--mini');
        capture('concierge_dock_moment', { experiment: EXPERIMENT, variant: 'dock', moment: best.id });
      }
    }
    function touch() { signals.lastAction = Date.now(); }
    doc.addEventListener('click', function (event) {
      if (!event.isTrusted || !event.target || !event.target.closest) return;
      touch();
      if (event.target.closest('.nh-shade-option-v2, .shade-option')) signals.shadeChanges += 1;
      if (event.target.closest('[data-nova-action="add-to-cart"], #mainCheckout, #stickyCtaBtn')) signals.addedToCart = true;
    }, true);
    doc.addEventListener('sales-page-commerce:added', function () { signals.addedToCart = true; touch(); });
    global.addEventListener('scroll', function () {
      touch();
      var height = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight) - global.innerHeight;
      if (height <= 0) return;
      var depth = Math.round(((global.scrollY || global.pageYOffset || 0) / height) * 100);
      if (depth > signals.maxDepth) signals.maxDepth = depth;
      var box = doc.querySelector('.bundle-cards-container, #buy');
      if (box && box.getBoundingClientRect().top < global.innerHeight * 0.8) signals.sawPrice = true;
    }, { passive: true });
    global.setInterval(applyMoment, 2000);
    /* The sticky buy bar owns the bottom of the screen and carries the price.
       Sit above whatever height it currently has, and follow it when it changes. */
    function sitAboveStickyBar() {
      var bar = doc.getElementById('stickyBuyBar') || doc.querySelector('.nh-sticky-v3');
      var clearance = 18;
      if (bar) {
        var rect = bar.getBoundingClientRect();
        var visible = rect.height > 0 && rect.bottom > global.innerHeight - 4;
        clearance = visible ? Math.round(rect.height) + 14 : 24;
      }
      button.style.setProperty('--nh-dock-bottom', 'calc(' + clearance + 'px + env(safe-area-inset-bottom,0px))');
    }
    sitAboveStickyBar();
    global.addEventListener('resize', sitAboveStickyBar, { passive: true });
    global.addEventListener('scroll', sitAboveStickyBar, { passive: true });
    var bar = doc.getElementById('stickyBuyBar') || doc.querySelector('.nh-sticky-v3');
    if (bar && global.MutationObserver) new MutationObserver(sitAboveStickyBar).observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });
    capture('concierge_dock_shown', { experiment: EXPERIMENT, variant: 'dock' });
    global.setTimeout(function () { button.classList.add('nh-dock--mini'); }, 7000);
    button.addEventListener('mouseenter', function () { button.classList.remove('nh-dock--mini'); });
    button.addEventListener('click', function () {
      capture('concierge_dock_opened', { experiment: EXPERIMENT, variant: 'dock', seconds_since_shown: Math.round((Date.now() - shownAt) / 1000) });
      if (currentMoment !== 'price_pause' && cdEligible()) { var arm = cdArm(); cdEnter(arm, currentMoment); if (arm === 'b') { shadeFirst(); return; } }
      openRegular();
    });
    function openRegular() {
      if (global.NovaHairAIPopup) { openConcierge(); return; }
      // Outside the quiz's exit share the concierge is not loaded yet: load it on this tap.
      if (typeof global.NovaCaptureLoadQuiz !== 'function') return;
      var node = labelNode();
      if (node) node.textContent = 'רגע, פותחת…';
      button.classList.remove('nh-dock--mini');
      global.NovaCaptureLoadQuiz();
      (function wait(n) {
        if (global.NovaHairAIPopup) { if (node) node.textContent = DEFAULT_LABEL; openConcierge(); return; }
        if (n < 40) global.setTimeout(function () { wait(n + 1); }, 200);
        else if (node) node.textContent = DEFAULT_LABEL;
      })(0);
    }
    function openConcierge() {
      var ai = global.NovaHairAIPopup;
      if (!ai || typeof ai.open !== 'function') return;
      try {
        ai.open({
          trigger: 'dock', reason: 'dock_tap', utmCampaign: global.location.search,
          pageVariant: doc.documentElement.getAttribute('data-nova-cro') || '',
          experimentId: EXPERIMENT, experimentVariant: 'dock', experimentBucket: 'dock', holdoutPercent: 0,
          intentScore: 0, engagementScore: 0, abandonScore: 0,
          snapshot: { maxDepth: 0, depth: 0, velocity: 0, engagedSeconds: Math.round((Date.now() - shownAt) / 1000), timeOnPage: Math.round((Date.now() - shownAt) / 1000), visit: 1 }
        });
      } catch (_) {}
    }
  }

  /* The button can show when the concierge is loaded, or when it can be loaded on a tap. */
  function ready() { return !!global.NovaHairAIPopup || typeof global.NovaCaptureLoadQuiz === 'function'; }

  /* nh-cd: a woman who already opened the button keeps her arm on every later event for 14 days. */
  try { var cdSeen = /^([ab])\.(\d+)$/.exec(global.localStorage.getItem('nh_cd') || ''); if (cdSeen && Date.now() - +cdSeen[2] < 12096e5 && global.posthog && typeof global.posthog.register === 'function') global.posthog.register({ nh_cd: cdSeen[1] }); } catch (_) {}

  function decide(tries) {
    if (tries > 0 && !ready() && tries < 20) { global.setTimeout(function () { decide(tries + 1); }, 500); return; }
    global.fetch(ENDPOINT + '?visitor=' + encodeURIComponent(visitorKey()) + '&experiment=' + EXPERIMENT, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (body) {
        var variant = body && body.variant ? String(body.variant) : 'control';
        remember(variant);
        if (variant === 'dock') {
          if (ready()) mount();
          else (function wait(n) { if (ready()) mount(); else if (n < 40) global.setTimeout(function () { wait(n + 1); }, 500); })(0);
        }
      })
      .catch(function () {});
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { decide(0); }); else decide(0);
})(window);
